/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetSelfEmployedTransactionQueryResponse, GetSelfEmployedTransactionPathParams, GetSelfEmployedTransaction400, GetSelfEmployedTransaction401, GetSelfEmployedTransaction404, GetSelfEmployedTransaction500 } from "../entities/GetSelfEmployedTransaction";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getSelfEmployedTransaction } from "../api/getSelfEmployedTransaction";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getSelfEmployedTransactionQueryKey = (id: GetSelfEmployedTransactionPathParams["id"] | undefined) => [{ url: '/api/v1/self-employed/transactions/:id', params: {id:id} }] as const

export type GetSelfEmployedTransactionQueryKey = ReturnType<typeof getSelfEmployedTransactionQueryKey>

export function getSelfEmployedTransactionQueryOptions(id: GetSelfEmployedTransactionPathParams["id"] | undefined, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getSelfEmployedTransactionQueryKey(id)
        return queryOptions<GetSelfEmployedTransactionQueryResponse, ResponseErrorConfig<GetSelfEmployedTransaction400 | GetSelfEmployedTransaction401 | GetSelfEmployedTransaction404 | GetSelfEmployedTransaction500>, GetSelfEmployedTransactionQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return getSelfEmployedTransaction(id!, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Возвращает данные операции.
 * `amount` — сумма после вычета, в копейках, без знака.
 * `date` — дата операции (RFC3339).
 * `status` (`success`, `waiting`, `canceled`) есть только у `order` и `payout`.
 * У `compensation`, `refund`, `dotaion` и `achivment` поля `status` нет.
 * `type`: `order`, `payout`, `compensation`, `refund`, `dotaion`, `achivment`.
 * `details` — разбивка суммы. Для `type=order`:
 * - `ride_amount` — стоимость поездки, в копейках
 * - `service_fee` — платёж Drivee, в копейках, со знаком
 * - `vat.rate` — ставка НДС, доля (`0.22` = 22%)
 * - `vat.amount` — сумма НДС, в копейках, со знаком
 * - `total` — итог, в копейках
 * - `reward` — награда за цель, если есть: `start_at`, `end_at`, `order_count`
 * Для типов без разбивки `details` равен `null`.
 * **Требования:**
 * - JWT access-токен водителя в заголовке `Authorization: Bearer <token>`. Водитель берётся
 * из токена (`user_id` в claims), заголовки `user-id` и `city-id` не нужны и не учитываются
 * Операция ищется по `id` и `user_id` из токена.
 * Чужая операция не отдаётся: ответ тот же `404`, что и для несуществующего `id`.
 * Так перебор `id` не показывает, есть ли операция у другого пользователя.
 * @summary Подробная информация о транзакции
 * {@link /api/v1/self-employed/transactions/:id}
 */
export function useGetSelfEmployedTransaction<TData = GetSelfEmployedTransactionQueryResponse, TQueryData = GetSelfEmployedTransactionQueryResponse, TQueryKey extends QueryKey = GetSelfEmployedTransactionQueryKey>(id: GetSelfEmployedTransactionPathParams["id"] | undefined, options: 
{
  query?: Partial<QueryObserverOptions<GetSelfEmployedTransactionQueryResponse, ResponseErrorConfig<GetSelfEmployedTransaction400 | GetSelfEmployedTransaction401 | GetSelfEmployedTransaction404 | GetSelfEmployedTransaction500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getSelfEmployedTransactionQueryKey(id)
         

         const query = useQuery({
          ...getSelfEmployedTransactionQueryOptions(id, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetSelfEmployedTransaction400 | GetSelfEmployedTransaction401 | GetSelfEmployedTransaction404 | GetSelfEmployedTransaction500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}